import { render } from "./ArchivedFilesIndex.vue?vue&type=template&id=470a523e&scoped=true"
import script from "./ArchivedFilesIndex.vue?vue&type=script&lang=js"
export * from "./ArchivedFilesIndex.vue?vue&type=script&lang=js"

import "./ArchivedFilesIndex.vue?vue&type=style&index=0&id=470a523e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470a523e"]])

export default __exports__